import axios from "axios";
import { getToken } from "../../../auth/authService";

const api = axios.create({
 baseURL: process.env.REACT_APP_BASE_URL,
 headers: {
 "Content-Type": "application/json",
 },
});

// Add auth header to every request
api.interceptors.request.use((config) => {
 const token = getToken();
 if (token) {
 config.headers.Authorization = `Bearer ${token}`;
 }
 return config;
});

// List vocabulary groups with pagination and search
export const fetchVocabularyGroups = async (params) => {
 try {
 const res = await api.get("/admin/vocabulary-groups", { params });
 return {
 status: res.status,
 data: res.data,
 };
 } catch (err) {
 return {
 status: err.response?.status || 500,
 data: null,
 message: err.response?.data?.message || "Failed to fetch vocabulary groups",
 };
 }
};

// Get vocabulary group by ID
export const fetchVocabularyGroupById = async (id) => {
 try {
 const res = await api.get(`/admin/vocabulary-groups/${id}`);
 return {
 status: res.status,
 data: res.data,
 };
 } catch (err) {
 return {
 status: err.response?.status || 500,
 data: null,
 message: err.response?.data?.message || "Failed to fetch vocabulary group",
 };
 }
};

// Create vocabulary group
export const createVocabularyGroup = async (payload) => {
 try {
 const res = await api.post("/admin/vocabulary-groups", payload);
 return {
 status: res.status,
 data: res.data,
 message: "Vocabulary group created successfully",
 };
 } catch (err) {
 return {
 status: err.response?.status || 500,
 message: err.response?.data?.message || "Create failed",
 };
 }
};

// Update vocabulary group
export const updateVocabularyGroup = async (id, payload) => {
 try {
 const res = await api.put(`/admin/vocabulary-groups/${id}`, payload);
 return {
 status: res.status,
 data: res.data,
 message: "Updated successfully",
 };
 } catch (err) {
 return {
 status: err.response?.status || 500,
 message: err.response?.data?.message || "Update failed",
 };
 }
};

// Delete vocabulary group
export const deleteVocabularyGroup = async (id) => {
 try {
 const res = await api.delete(`/admin/vocabulary-groups/${id}`);
 return {
 status: res.status,
 message: "Vocabulary group deleted successfully",
 };
 } catch (err) {
 return {
 status: err.response?.status || 500,
 message: err.response?.data?.message || "Delete failed",
 };
 }
};

// Fetch vocabularies for dropdown (reusing existing service)
export const fetchVocabulariesForDropdown = async (params) => {
 try {
 const res = await api.get("/admin/vocabulary", { params });
 return {
 status: res.status,
 data: res.data,
 };
 } catch (err) {
 return {
 status: err.response?.status || 500,
 data: null,
 message: err.response?.data?.message || "Failed to fetch vocabularies",
 };
 }
};